export enum LiquibaseCommands {
  CalculateCheckSum = 'calculateCheckSum',
  ChangelogSync = 'changelogSync',
  ChangelogSyncSql = 'changelogSyncSQL',
  ChangelogSyncToTag = 'changelogSyncToTag',
  ChangelogSyncToTagSql = 'changelogSyncToTagSQL',
  ChecksBulkSet = 'checksBulkSet',
  ChecksCopy = 'checksCopy',
  ChecksCreate = 'checksCreate',
  ChecksCustomize = 'checksCustomize',
  ChecksDelete = 'checksDelete',
  ChecksDisable = 'checksDisable',
  ChecksEnable = 'checksEnable',
  ChecksReset = 'checksReset',
  ChecksRun = 'checksRun',
  ChecksShow = 'checksShow',
  ClearCheckSums = 'clearCheckSums',
  Connect = 'connect',
  DbDoc = 'dbDoc',
  DbclHistory = 'dbclHistory',
  DeactivateChangeLog = 'deactivateChangeLog',
  Diff = 'diff',
  DiffChangeLog = 'diffChangeLog',
  DropAll = 'dropAll',
  ExecuteSql = 'executeSql',
  Flow = 'flow',
  FutureRollbackSql = 'futureRollbackSQL',
  FutureRollbackCountSql = 'futureRollbackCountSQL',
  GenerateChangeLog = 'generateChangeLog',
  Help = 'help',
  History = 'history',
  Init = 'init',
  InitCopy = 'init Copy',
  InitProject = 'init Project',
  InitStartH2 = 'init StartH2',
  ListLocks = 'listLocks',
  MarkNextChangeSetRan = 'markNextChangeSetRan',
  MarkNextChangeSetRanSql = 'markNextChangeSetRanSQL',
  RegisterChangeLog = 'registerChangeLog',
  ReleaseLocks = 'releaseLocks',
  Rollback = 'rollback',
  RollbackCount = 'rollbackCount',
  RollbackCountSql = 'rollbackCountSQL',
  RollbackSql = 'rollbackSQL',
  RollbackToDate = 'rollbackToDate',
  RollbackToDateSql = 'rollbackToDateSQL',
  RollbackOneChangeset = 'rollbackOneChangeset',
  RollbackOneChangesetSql = 'rollbackOneChangesetSQL',
  RollbackOneUpdate = 'rollbackOneUpdate',
  RollbackOneUpdateSql = 'rollbackOneUpdateSQL',
  SetContexts = 'setContexts',
  SetLabels = 'setLabels',
  Snapshot = 'snapshot',
  SnapshotReference = 'snapshotReference',
  Status = 'status',
  SyncHub = 'syncHub',
  Tag = 'tag',
  TagExists = 'tagExists',
  UnexpectedChangeSets = 'unexpectedChangeSets',
  Update = 'update',
  UpdateSql = 'updateSQL',
  UpdateCount = 'updateCount',
  UpdateCountSql = 'updateCountSQL',
  UpdateTestingRollback = 'updateTestingRollback',
  UpdateToTag = 'updateToTag',
  UpdateToTagSql = 'updateToTagSQL',
  UpdateOneChangeset = 'updateOneChangeset',
  UpdateOneChangesetSql = 'updateOneChangesetSQL',
  Validate = 'validate',
}
